import React, { Fragment, useCallback, useRef, useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { Spinner } from '../../../../AbstractElements';
import { Button, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Media, Row, UncontrolledDropdown, } from 'reactstrap';
import { MoreVertical, PlusCircle } from 'react-feather';
import CommonModal from '../../../UiKits/Modals/common/modal'
import axios from 'axios';
import moment from 'moment';
import { spinnerData } from './data'
import Swal from 'sweetalert2';
import { baseURL, imageURL } from '../../../../Services/api/baseURL';
import { FaPen } from 'react-icons/fa';
import Loader from '../../../Loader/Loader';
import useRbac from '../../../../Hooks/useRbac';
import { SeoMetaFields } from '../../../Common/SeoMetaFields';
import { getCollectionSeoPreviewUrl } from '../../../../utils/seoPreviewUrls';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import dummyImg from '../../../../assets/images/product/2.png';
import { Image } from '../../../../AbstractElements';
import UploadOverlay from '../../../Common/UploadOverlay/UploadOverlay';

export const products = [
    {
        id: 1,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'active',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
    {
        id: 2,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'Inactive',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
    {
        id: 3,
        collectionName: 'Beers & Ciders',
        addedBy: 'Ravi',
        status: 'active',
        createdBy: '14/01/2024',
        UpdatedBy: '22/01/2024',

    },
]

// ─── Image field helpers ───────────────────────────────────────────────────────

/** Aspect ratios for each collection image type */
const IMAGE_CONFIGS = {
    icon:         { label: 'Category Icon',          aspect: 1,        description: '1:1 (square, circular display)' },
    thumbnail:    { label: 'Category Thumbnail',     aspect: 4 / 3,   description: '4:3' },
    bannerWeb:    { label: 'Category Banner (Web)',   aspect: 33 / 5,   description: '33:5 — full-width web banner' },
    bannerMobile: { label: 'Category Banner (Mobile)',aspect: 1,        description: '1:1 — full-width mobile banner' },
};

const IMAGE_FIELDS = Object.keys(IMAGE_CONFIGS);

/**
 * Single image section component (browse + crop + preview).
 * Follows the same react-image-crop pattern as contentManagementTable.jsx.
 */
function CollectionImageField({ fieldKey, config, file, setFile, existingUrl }) {
    const inputRef = useRef();
    const imgRef = useRef(null);
    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState(null);
    const [preview, setPreview] = useState(existingUrl || '');

    // Re-sync preview when existing URL changes (edit mode)
    useEffect(() => { setPreview(existingUrl || ''); }, [existingUrl]);

    const handleFileSelect = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;
        const reader = new FileReader();
        reader.onload = (ev) => setSrc(ev.target.result);
        reader.readAsDataURL(selected);
    };

    const onImageLoaded = (e) => {
        const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
        const c = centerCrop(
            makeAspectCrop({ unit: '%', width: 100 }, config.aspect, w, h),
            w, h
        );
        setCrop(c);
    };

    const onCropComplete = async (completedCrop) => {
        if (!imgRef.current || !completedCrop?.width) return;
        const canvas = document.createElement('canvas');
        const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
        // Export at the source image's native resolution (not the on-screen crop size)
        // Clamp to the image bounds so rounding never leaves undrawn edge pixels
        const sx = Math.max(0, Math.round(completedCrop.x * scaleX));
        const sy = Math.max(0, Math.round(completedCrop.y * scaleY));
        const outW = Math.min(Math.round(completedCrop.width * scaleX), imgRef.current.naturalWidth - sx);
        const outH = Math.min(Math.round(completedCrop.height * scaleY), imgRef.current.naturalHeight - sy);
        canvas.width = outW;
        canvas.height = outH;
        const ctx = canvas.getContext('2d');
        // JPEG has no alpha — paint white first so transparent pixels don't turn black
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, outW, outH);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(imgRef.current, sx, sy, outW, outH, 0, 0, outW, outH);
        canvas.toBlob((blob) => {
            if (!blob) return;
            blob.name = `${fieldKey}_${Date.now()}.jpeg`;
            setFile(blob);
            setPreview(URL.createObjectURL(blob));
        }, 'image/jpeg', 1);
    };

    return (
        <Col xl={6} className='mb-3'>
            <FormGroup>
                <Label className='font-medium text-base'>
                    {config.label}
                    <small className='text-muted ms-2'>({config.description})</small>
                </Label>
                <div>
                    <input
                        type='file'
                        hidden
                        ref={inputRef}
                        accept='image/png, image/jpeg, image/gif'
                        onChange={handleFileSelect}
                    />
                    <Button type='button' className='btn btn-secondary btn-sm' onClick={() => inputRef.current.click()}>
                        Browse File
                    </Button>
                </div>
                {src ? (
                    <div className='mt-2'>
                        <ReactCrop
                            crop={crop}
                            onChange={setCrop}
                            onComplete={onCropComplete}
                            aspect={config.aspect}
                            keepSelection
                        >
                            <img
                                ref={imgRef}
                                src={src}
                                onLoad={onImageLoaded}
                                alt={config.label}
                                style={{ maxWidth: '100%' }}
                            />
                        </ReactCrop>
                    </div>
                ) : preview ? (
                    <div className='mt-2'>
                        <img
                            src={preview}
                            alt={config.label}
                            style={{
                                maxWidth: '100%',
                                maxHeight: fieldKey === 'icon' ? '80px' : '120px',
                                borderRadius: fieldKey === 'icon' ? '50%' : '4px',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                ) : null}
            </FormGroup>
        </Col>
    );
}

// ─── Main Component ────────────────────────────────────────────────────────────

const CollectionTable = () => {
    const userRole = JSON.parse(localStorage.getItem('role_name'));
    const { can, canAny } = useRbac();
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [editData, setEditData] = useState([]);
    const [data, setData] = useState(products);
    const [searchTerm, setSearchTerm] = useState('');
    const [AddModal, SetAddmodal] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [addExcel, setAddExcel] = useState(false)
    const [selectedOption, setSelectedOption] = useState('active');
    const [CollectionData, setCollectionData] = useState([])
    const [collectionName, setCollectionName] = useState()
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [deleteModal, setDeleteModal] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [quantity, setQuantity] = useState("");

    // ─── Image file state (one per image type) ────────────────────────────────
    const [iconFile, setIconFile] = useState(null);
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [bannerWebFile, setBannerWebFile] = useState(null);
    const [bannerMobileFile, setBannerMobileFile] = useState(null);

    // Existing image URLs (for edit mode pre-fill)
    const [existingIcon, setExistingIcon] = useState('');
    const [existingThumbnail, setExistingThumbnail] = useState('');
    const [existingBannerWeb, setExistingBannerWeb] = useState('');
    const [existingBannerMobile, setExistingBannerMobile] = useState('');
    // ─────────────────────────────────────────────────────────────────────────

    const resetImageState = () => {
        setIconFile(null);
        setThumbnailFile(null);
        setBannerWebFile(null);
        setBannerMobileFile(null);
        setExistingIcon('');
        setExistingThumbnail('');
        setExistingBannerWeb('');
        setExistingBannerMobile('');
    };

    const AddMOdalToggle = () => {
        SetAddmodal(!AddModal)
        setEditData(null)
        setCollectionName(null);
        setQuantity("");
        setMetaTitle("");
        setMetaDescription("");
        resetImageState();
    }
    const addmodalExcel = () => setAddExcel(!addExcel)
    const handleSearch = (event) => {
        event.preventDefault();
        setSearchTerm(event.target.value);
    };
    const orderColumns = [
        {
            name: 'Thumbnail',
            width: '100px',
            cell: (row) => (
                <Media className='d-flex align-items-center'>
                    <Image attrImage={{
                        className: 'img-30',
                        src: row?.thumbnail ? imageURL + row.thumbnail : dummyImg,
                        alt: row.collection_name
                    }} />
                </Media>
            ),
            center: true,
        },
        {
            name: 'Collection Name',
            selector: row => row['collection_name'],
            sortable: true,
            center: true,
            cell: (row) => (
                row.collection_name
            )
        },
        {
            name: 'Status',
            selector: row => `${row.status}`,
            sortable: true,
            center: true,
            cell: (row) => (
                <p className={`text-${row.status === "inactive" ? "[#ff0000]" : "[#008800]"}`}>{row.status === "active" ? "Active" : "In-Active"}</p>
            )
        },
        {
            name: 'Meta Title',
            selector: row => row['metaTitle'],
            sortable: true,
            center: true,
            cell: (row) => (
                row.metaTitle
            )
        },
        {
            name: 'Meta Description',
            selector: row => row['metaDescription'],
            sortable: true,
            center: true,
            cell: (row) => (
                row.metaDescription
            )
        },
        {
            name: 'Created Date',
            selector: row => `${row.createdAt}`,
            cell: (row) => (
                moment(row.createdAt).format("DD/MM/YYYY")
            ),
            sortable: true,
            center: true,
        },
        {
            name: 'Updated Date',
            selector: row => `${row.updatedAt}`,
            sortable: true,
            center: true,
            cell: (row) => (
                moment(row.updatedAt).format("DD/MM/YYYY")
            ),

        },
        {
            name: 'Actions',
            omit: !canAny(['collections.update', 'collections.change_status']),
            cell: (row) => (

                <>
                    <UncontrolledDropdown className='action_dropdown'>
                        <DropdownToggle className='action_btn'
                        >
                            <MoreVertical color='#000' size={16} />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => {
                                setEditData(row)
                                setCollectionName(row.collection_name)
                                setQuantity(row.quantity)
                                setMetaTitle(row.metaTitle || "")
                                setMetaDescription(row.metaDescription || "")
                                setSelectedOption(row.status)
                                // Pre-fill existing image URLs for edit mode
                                setExistingIcon(row.icon ? imageURL + row.icon : '');
                                setExistingThumbnail(row.thumbnail ? imageURL + row.thumbnail : '');
                                setExistingBannerWeb(row.bannerWeb ? imageURL + row.bannerWeb : '');
                                setExistingBannerMobile(row.bannerMobile ? imageURL + row.bannerMobile : '');
                                SetAddmodal(true)
                            }}>
                                Edit
                                <FaPen />
                            </DropdownItem>
                            <DropdownItem
                                onClick={(rowData) => {
                                    setEditData(row)
                                    setDeleteModal(!deleteModal)
                                }}>
                                Change Status
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </>
            ),
            sortable: false,
            center: true,
        }
    ];

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = () => {
        if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
            setToggleDelet(!toggleDelet);

            setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
            setSelectedRows('');
        }
    };

    const fetchCollections = async (page) => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const collectData = await axios.get(`${baseURL}/api/admin/get-collections?page=${page}&limit=${perPage}`, {
                headers: {
                    Authorization: `${token}`,
                }
            })
            setCollectionData(collectData.data.data);
            setTotalRows(collectData.data.total);
        } catch (error) {
            console.log(error)
        }
    }

    const handlePageChange = (page) => {
        fetchCollections(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);

        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const collectData = await axios.get(`${baseURL}/api/admin/get-collections?page=${page}&limit=${newPerPage}`, {
                headers: {
                    Authorization: `${token}`,
                }
            })
            setCollectionData(collectData.data.data)
            setPerPage(newPerPage);
            setLoading(false);
        } catch (error) {
            setLoading(false)
            console.log(error)
        }


    };

    /** Build FormData with text fields + any image files that were selected */
    const buildFormData = () => {
        const formData = new FormData();
        collectionName && formData.append('collection_name', collectionName);
        quantity && formData.append('quantity', quantity);
        formData.append('metaTitle', metaTitle || '');
        formData.append('metaDescription', metaDescription || '');

        // Append images only if a new file was selected
        if (iconFile)         formData.append('icon', iconFile);
        if (thumbnailFile)    formData.append('thumbnail', thumbnailFile);
        if (bannerWebFile)    formData.append('bannerWeb', bannerWebFile);
        if (bannerMobileFile) formData.append('bannerMobile', bannerMobileFile);

        return formData;
    };

    const PostCollections = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            setIsUploading(true);
            const formData = buildFormData();
            await axios.post(`${baseURL}/api/admin/add-collection`, formData, {
                headers: {
                    Authorization: `${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            })
            setIsUploading(false);
            AddMOdalToggle()
            fetchCollections(1);
            Swal.fire({
                title: "Collection Added!",
                icon: "success",
                confirmButtonColor: "#d3178a",
            });
        } catch (error) {
            setIsUploading(false);
            console.log(error, 'post')
            Swal.fire({ title: error?.response?.data?.message || 'Upload failed', icon: 'error', confirmButtonColor: '#d3178a' });
        }
    }

    const EditCollections = async (id) => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            setIsUploading(true);
            const formData = buildFormData();
            await axios.patch(`${baseURL}/api/admin/update-collection/${id}`, formData, {
                headers: {
                    Authorization: `${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            })
            setIsUploading(false);
            SetAddmodal(!AddModal)
            resetImageState();
            fetchCollections(1);
            Swal.fire({
                title: "Updated Collection!",
                icon: "success",
                confirmButtonColor: "#d3178a",
            });
        } catch (error) {
            setIsUploading(false);
            console.log(error, 'edit')
            Swal.fire({ title: error?.response?.data?.message || 'Update failed', icon: 'error', confirmButtonColor: '#d3178a' });
        }
    }
    const inActiveCollections = async (id) => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const collectData = await axios.patch(`${baseURL}/api/admin/update-collection-status/${id}`, { status: selectedOption }, {
                headers: {
                    Authorization: `${token}`,
                }
            })
            SetAddmodal(!AddModal)
            fetchCollections(1);
        } catch (error) {
            console.log(error, 'edit')
        }
    }
    useEffect(() => {
        fetchCollections(1);
    }, [])
    const handleOptionChange = (value) => {
        setSelectedOption(value);
    };

    const inactiveItem = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            const obj = {
                status: editData.status === "inactive" ? "active" : 'inactive'
            }

            const itemsData = await axios.patch(`${baseURL}/api/admin/update-collection-status/${editData._id}`, obj, {
                headers: {
                    Authorization: `${token}`,
                }
            })

            fetchCollections(1)
            setDeleteModal(!deleteModal)
        }
        catch (err) {
            console.log(err)
        }
    }


    const handlePostCollections = (row) => {
        if (editData === null) {
            PostCollections()
        } else {
            if (editData.status !== selectedOption && editData.collection_name === collectionName) {
                inActiveCollections(editData._id)

            } else {
                EditCollections(editData._id)

            }
        }


    }
    const handleActiveCollections = (row) => {
        setEditData(row)
        SetAddmodal(!AddModal)

        if (editData !== null) {
            setSelectedOption(editData.status)
            inActiveCollections(editData._id)
        }

    }
    const filteredCollections = CollectionData.filter(item =>
        item?.collection_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <Fragment>
            <Row xxl={12} className='pb-4'>
                <div className='d-flex justify-content-between align-items-center'>
                    <h5 className="fw-bolder">Category List</h5>
                    <div className="file-content">
                        <Media>
                            <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                <i className='fa fa-search'></i>
                                <input className='form-control border-0' value={searchTerm} onChange={(e) => handleSearch(e)} type='text' placeholder='Search...' />
                            </div>
                            {
                                can('collections.create') && <Media body className='text-end ms-3'>
                                    <Button className='btn btn-primary d-flex align-items-center' onClick={AddMOdalToggle}>
                                        <PlusCircle />
                                        Add Collection
                                    </Button>
                                </Media>
                            }

                        </Media>
                    </div>
                </div>
            </Row>

            {
                CollectionData.length !== 0 ?
                    (<DataTable
                        data={filteredCollections || []}
                        columns={orderColumns}
                        pagination
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleDelet}
                        progressPending={loading} paginationServer
                        progressComponent={<Loader />}
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                    />) : (
                        <>
                            {
                                spinnerData.map((spinner) =>
                                    <Col xxl="12" key={spinner.id} className='flex justify-center items-center'>
                                        <div className="loader-box">
                                            <Spinner attrSpinner={{ className: spinner.spinnerClass }} />
                                        </div>
                                    </Col>
                                )
                            }
                        </>
                    )}

            <CommonModal isOpen={AddModal} title={editData ? "Edit Collection" : "Add New Collection"} className="store_modal" toggler={AddMOdalToggle} size="xl">
                <Container>
                    <Form >
                        <>
                            <Row>
                                <Col xl={6}>
                                    <FormGroup>
                                        <Label className='font-medium text-base'>Collection Name <span className='text-danger'>*</span></Label>
                                        <Input name='collectionName' value={collectionName} onChange={(e) => setCollectionName(e.target.value)} placeholder='Enter Collection Name' />
                                    </FormGroup>
                                </Col>
                                <Col xl={6}>
                                    <FormGroup>
                                        <Label className='font-medium text-base'>Order Max Quantity<span className='text-danger'>*</span></Label>
                                        <select
                                            className='form-control'
                                            name='quantity'
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                        >
                                            <option value={''} disabled>Select Max Order Quantity</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </FormGroup>
                                </Col>
                                <Col xl={12}>
                                    <SeoMetaFields
                                        metaTitle={metaTitle}
                                        metaDescription={metaDescription}
                                        onMetaTitleChange={(e) => setMetaTitle(e.target.value)}
                                        onMetaDescriptionChange={(e) => setMetaDescription(e.target.value)}
                                        urlPreview={
                                            editData?.slug || collectionName
                                                ? getCollectionSeoPreviewUrl({
                                                    slug: editData?.slug,
                                                    name: collectionName,
                                                })
                                                : undefined
                                        }
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={12}>
                                    <hr />
                                    <h6 className='fw-bold mb-3'>Collection Images <small className='text-muted fw-normal'>(optional — upload only the images you want to update)</small></h6>
                                </Col>

                                <CollectionImageField
                                    fieldKey='icon'
                                    config={IMAGE_CONFIGS.icon}
                                    file={iconFile}
                                    setFile={setIconFile}
                                    existingUrl={existingIcon}
                                />
                                <CollectionImageField
                                    fieldKey='thumbnail'
                                    config={IMAGE_CONFIGS.thumbnail}
                                    file={thumbnailFile}
                                    setFile={setThumbnailFile}
                                    existingUrl={existingThumbnail}
                                />
                                <CollectionImageField
                                    fieldKey='bannerWeb'
                                    config={IMAGE_CONFIGS.bannerWeb}
                                    file={bannerWebFile}
                                    setFile={setBannerWebFile}
                                    existingUrl={existingBannerWeb}
                                />
                                <CollectionImageField
                                    fieldKey='bannerMobile'
                                    config={IMAGE_CONFIGS.bannerMobile}
                                    file={bannerMobileFile}
                                    setFile={setBannerMobileFile}
                                    existingUrl={existingBannerMobile}
                                />
                            </Row>
                        </>
                        <Row>
                            <Col xxl={12} className='modal_btm d-flex justify-content-end'>
                                <Button type='button' disabled={isUploading} onClick={handlePostCollections} className='cursor-pointer bg-[#ff0000] font-medium w-40 mt-4 px-2 py-2 rounded-2xl text-white flex justify-center items-center'>
                                    {isUploading ? 'Uploading…' : (editData ? 'Update Collection' : 'Save Collection')}
                                </Button>
                            </Col>
                        </Row>
                        <UploadOverlay isVisible={isUploading} message={editData ? 'Updating collection…' : 'Saving collection…'} />
                    </Form>
                </Container>
            </CommonModal>
            <CommonModal isOpen={deleteModal} title="" toggler={() => { setDeleteModal(!deleteModal) }} size="md">
                <Container className='flex flex-col justify-center items-center'>
                    <p>Do You Want To Change Status Of This Collection? </p>
                    <div className='flex flex-row space-x-8'>
                        <div onClick={() => setDeleteModal(!deleteModal)} className='border-1 border-[#ff0000] px-2 py-2 text-[#ff0000] rounded-xl cursor-pointer'>Cancel</div>
                        <div onClick={inactiveItem} className='bg-[#ff0000] px-4 py-2 text-white rounded-xl cursor-pointer'>Yes</div>
                    </div>

                </Container>
            </CommonModal>
        </Fragment>
    )
}
export default CollectionTable